import { Offcanvas } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import OffRateHistory from "./OffRateHistory";
import OffRateNewRate from "./OffRateNewRate";

const OffRate = ({show, setShow}) => {

    const { t } = useTranslation(['Rate']);

     

    return (
        <Offcanvas 
            placement="end"
            show={show} 
            onHide={()=>setShow(false)}>
            <Offcanvas.Header 
                className="border-bottom"
                closeButton>
            <Offcanvas.Title>{t('title')}</Offcanvas.Title>
            </Offcanvas.Header>
                <Offcanvas.Body className="px-0">
                    <OffRateNewRate setShow={setShow}/>
                    <OffRateHistory/>
                </Offcanvas.Body>
        </Offcanvas>
    )
}

export default OffRate;